import React from 'react';

import { Stack } from '@mui/material';

import OpportunityDatesAndPolicies from './sections/OpportunityDatesAndPolicies';
import OpportunityDealDetails from './sections/OpportunityDealDetails';
import OpportunityInformation from './sections/OpportunityInformation';

interface Props {
  opportunityResponse: App.OpportunityPage;
  dealsResponse: Array<App.Deal>;
  isAdminRole: boolean;
  offerResponse: App.Offer;
  vendorId: string;
  offerId: string;
  accountName: string;
}

export default function OpportunityPage({
  opportunityResponse,
  dealsResponse,
  isAdminRole,
  offerId,
  offerResponse,
  vendorId,
  accountName,
}: Props) {
  const {
    opportunity_info,
    key_contacts,
    key_commercial,
    additional_questions,
    contract,
    key_dates,
    black_out_dates,
    functional_details,
  } = opportunityResponse || {};

  return (
    <Stack px={2} className="opportunity" sx={{ minHeight: 0 }}>
      <OpportunityInformation
        opportunityInfo={opportunity_info}
        keyContacts={key_contacts}
        keyCommercial={key_commercial}
        isAdmin={isAdminRole}
        accountName={accountName}
      />
      <OpportunityDealDetails
        deals={dealsResponse}
        opportunityInfo={opportunity_info}
        additionalQuestions={additional_questions}
        contract={contract}
        isAdmin={isAdminRole}
        offerId={offerId}
        offerResponse={offerResponse}
        vendorId={vendorId}
      />
      <OpportunityDatesAndPolicies
        keyDates={key_dates}
        blackOutDates={black_out_dates}
        functionalDetails={functional_details}
        isAdmin={isAdminRole}
        offerResponse={offerResponse}
        brand={opportunity_info?.brand}
      />
    </Stack>
  );
}
